import { render } from "./BaseQuantitySlider.vue?vue&type=template&id=3b827803&scoped=true"
import script from "./BaseQuantitySlider.vue?vue&type=script&lang=js"
export * from "./BaseQuantitySlider.vue?vue&type=script&lang=js"

import "./BaseQuantitySlider.vue?vue&type=style&index=0&id=3b827803&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b827803"]])

export default __exports__